/**
 * @private
 */
// Export constants for direct import
export const RIBBON_ID = '_ribbon';
